export default __webpack_public_path__ + "static/3-214845309701401c6d6d98219a6e3e1a.png";